import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17.688 11.75c0 .383-.301.656-.657.656H6.97a.63.63 0 0 1-.657-.656c0-.355.274-.656.657-.656H17.03c.356 0 .657.3.657.656"
    }, null, -1)
  ]))]))
}
export default { render: render }